import format from 'date-fns/format';

function round(value, decimals = 2) {
	const newValue = Number(value);
	return newValue.toFixed(decimals);
}

function limitTo(value, length = 10) {
	const cutText = value.substring(0, length);
	return `${cutText}...`;
}

function formatDate(date, formatter = 'YYYY-MM-DD') {
	const newDate = format(new Date(date), formatter);
	return newDate;
}

export default function (Vue) {
	Vue.filter('round', round);
	Vue.filter('limitTo', limitTo);
	Vue.filter('formatDate', formatDate);
}



// WEBPACK FOOTER //
// ./src/filters/global.js